import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const fetchCourses = (vendor) =>
  api.get(`/courses${vendor ? `?vendor=${encodeURIComponent(vendor)}` : ""}`).then((r) => r.data);

export const fetchBlogPosts = () => api.get(`/blog`).then((r) => r.data);
export const fetchBlogPost = (slug) => api.get(`/blog/${slug}`).then((r) => r.data);

export const submitDemoSignup = (payload) => api.post(`/demo-signup`, payload).then((r) => r.data);
export const submitContact = (payload) => api.post(`/contact`, payload).then((r) => r.data);
